export enum CheckoutLayoutType {
  NO_BANNER = 'no_banner',
  TOP_AND_BOTTOM_BANNER = 'top_and_bottom_banner',
  FULL_BANNER = 'full_banner',
}

